import { toast } from 'react-toastify';
import { toastConfig } from '../@config/toasts';
export const showToast = async (type, params) => {
    const { title, message, onClick, props } = params;
    if (!toastConfig.hasOwnProperty(type)) {
        return Promise.reject('Unknown toast type');
    }
    toast(toastConfig[type]({
        title,
        message,
        onClick,
        props,
    }));
};
